var _mask, _rect, _mask2, _path, _mask3, _path2, _mask4, _rect2, _mask5, _path3, _mask6, _path4, _mask7, _rect3, _mask8, _rect4, _mask9, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPricingEnterpriseIcon = function SvgPricingEnterpriseIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 72,
    fill: "none",
    viewBox: "0 0 92 72"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_3284_211859",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.208,
    height: 24.296,
    y: 47.16,
    rx: 1.433
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47.208,
    height: 24.296,
    y: 47.16,
    stroke: "#323338",
    strokeWidth: 5.73,
    mask: "url(#path-1-inside-1_3284_211859)",
    rx: 1.433
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-2_3284_211859",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.583 44.306c0-.792.642-1.433 1.433-1.433h8.58c.79 0 1.432.641 1.432 1.433v5.713H8.583z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#323338",
    strokeWidth: 5.73,
    d: "M8.583 44.306c0-.792.642-1.433 1.433-1.433h8.58c.79 0 1.432.641 1.432 1.433v5.713H8.583z",
    mask: "url(#path-2-inside-2_3284_211859)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-3_3284_211859",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.797 44.306c0-.792.64-1.433 1.432-1.433h8.58c.79 0 1.432.641 1.432 1.433v5.713H26.797z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323338",
    strokeWidth: 5.73,
    d: "M26.797 44.306c0-.792.64-1.433 1.432-1.433h8.58c.79 0 1.432.641 1.432 1.433v5.713H26.797z",
    mask: "url(#path-3-inside-3_3284_211859)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-4_3284_211859",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.208,
    height: 24.296,
    x: 18.597,
    y: 4.287,
    rx: 1.433
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 47.208,
    height: 24.296,
    x: 18.597,
    y: 4.287,
    stroke: "#323338",
    strokeWidth: 5.73,
    mask: "url(#path-4-inside-4_3284_211859)",
    rx: 1.433
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-5_3284_211859",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.18 1.433C27.18.64 27.822 0 28.614 0h8.58c.79 0 1.432.641 1.432 1.433v5.713H27.18z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323338",
    strokeWidth: 5.73,
    d: "M27.18 1.433C27.18.64 27.822 0 28.614 0h8.58c.79 0 1.432.641 1.432 1.433v5.713H27.18z",
    mask: "url(#path-5-inside-5_3284_211859)"
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "path-6-inside-6_3284_211859",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.777 1.433C45.777.64 46.418 0 47.209 0h8.58c.791 0 1.432.641 1.432 1.433v5.713H45.777z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323338",
    strokeWidth: 5.73,
    d: "M45.777 1.433C45.777.64 46.418 0 47.209 0h8.58c.791 0 1.432.641 1.432 1.433v5.713H45.777z",
    mask: "url(#path-6-inside-6_3284_211859)"
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-7_3284_211859",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.208,
    height: 24.296,
    x: 44.347,
    y: 25.723,
    rx: 1.433
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 47.208,
    height: 24.296,
    x: 44.347,
    y: 25.723,
    stroke: "#323338",
    strokeWidth: 5.73,
    mask: "url(#path-7-inside-7_3284_211859)",
    rx: 1.433
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "path-8-inside-8_3284_211859",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.208,
    height: 24.296,
    x: 44.347,
    y: 47.16,
    rx: 1.433
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 47.208,
    height: 24.296,
    x: 44.347,
    y: 47.16,
    stroke: "#323338",
    strokeWidth: 5.73,
    mask: "url(#path-8-inside-8_3284_211859)",
    rx: 1.433
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "path-9-inside-9_3284_211859",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.527 22.868c0-.791.64-1.432 1.432-1.432h8.58c.79 0 1.432.64 1.432 1.432v5.713H71.526z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#323338",
    strokeWidth: 5.73,
    d: "M71.527 22.868c0-.791.64-1.432 1.432-1.432h8.58c.79 0 1.432.64 1.432 1.432v5.713H71.526z",
    mask: "url(#path-9-inside-9_3284_211859)"
  })));
};
export default SvgPricingEnterpriseIcon;